export default {
    // "m" stand for "message"
    m: {
        confirm: 'OK',
        cancel: 'Cancel',
        save: 'Save',
        success: 'Succeeded',
        tip: 'Prompt',
        operateSuccess: 'Operation succeeded!',
        addSuccess: 'Successfully added!',
        editSuccess: 'Successfully modified!',
        delSuccess: 'Deleted successfully!',
        importSuccess: 'Imported successfully！',
        importFail: 'Import failed！',
        delete: 'Are you sure you want to delete this?',
        saveSuccess: 'Saved successfully!',
        edit: 'Are you sure you to edit this?',
        publish: 'Are you sure to publish this?',
        resetPwd: 'Are you sure to reset the password? The reset password will be changed to: ',
        coursingOrExit: 'The courseware is under preparation. Are you sure to exit?',
        paperingOrExit: 'The test paper is under preparation. Are you sure to exit?',
        paperDataNotSave: 'The current paper data will not be saved. Confirm to continue?',
        delCert: 'This operation will permanently delete this certificate. Continue?',
        titleRequired: 'The subject cannot be null!',
        submitPaper: 'Are you sure to submit the test paper?',
        submitUndonePaper: 'You still have {0} question(s) left. Are you sure to submit the test paper?',
        practiceResult: 'This practice contains {0} question(s), among which {1} question(s) is(are) successfully answered.',
        endingTime: 'The certificate retrieval date must be later than the certificate issue date!',
        checkCode: 'The verification code has been sent to your phone. Please check in time.',
        signOut: 'Are you sure to log out?',
        cycleUser: 'Are you sure to retrieve the selected user?',
        deleteUser: 'Are you sure to delete the selected user permanently?',
        pleaseComplete: 'Please fill in it completely!',
        emptyMenuLogin: 'Please configure menu data for this account first!',
        startExam: 'Are you sure to start the exam?',
        startResitExam: 'Are you sure to start the resit examination?',
        deleteImg: 'Are you sure you to delete these {0} images?'
    },
    // 各个组件公共的词条
    c: {
        all: 'All',
        back: 'Back',
        confirm: 'OK',
        cancel: 'Cancel',
        reset: 'Reset',
        success: 'Succeeded',
        operation: 'Operation',
        close: 'Close',
        save: 'Save',
        input: 'Input',
        add: 'Add',
        delete: 'Delete',
        edit: 'Edit',
        query: 'Query',
        view: 'View',
        preview: 'Preview',
        publish: 'Publish',
        unpublish: 'Unpublish',
        share: 'Share',
        select: 'Select',
        submit: 'Submit',
        finish: 'Finish',
        others: 'Others',
        settings: 'Settings',
        show: 'Show',
        size: 'Size',
        total: 'Total',
        to: 'To',
        prev: 'Previous',
        next: 'Next',
        fail: 'Fail',
        yes: 'Yes',
        no: 'No',
        NO: 'SN',
        none: 'N/A',
        type: 'Type',
        status: 'Status',
        description: 'Description',
        video: 'Video',
        audio: 'Audio',
        image: 'Image',
        theory: 'Theoritical',
        document: 'Document',
        logOut: 'Exit',
        date: 'Time',
        from: 'From',
        startTime: 'Start time',
        endTime: 'End time',
        startDate: 'Start date',
        endDate: 'End date',
        creator: 'Creator',
        creationTime: 'Creation time',
        makingTime: 'Preparation Time',
        modificationTime: 'Modification time',
        modificationBy: 'Modified By',
        noData: 'No data',
        noMore: 'No more',
        difficulty: 'Difficulty Degree',
        knowledgePoint: 'Knowledge Point',
        operatorLevel: 'Applicable Level',
        organizations: 'Organization',
        belong: 'Organization',
        trainingType: 'Training Category',
        examType: 'Test Mode',
        position: 'Position',
        occupation: 'Identity Type',
        userInfo: 'Individual Information',
        name: 'Name',
        username: 'Name',
        gender: 'Gender',
        phone: 'Mobile Number',
        role: 'Role',
        grade: 'Grade',
        education: 'Education Background',
        birthday: 'Date of Birth',
        idCardNo: 'ID card NO.',
        idNo: 'Employee ID',
        account: 'Account No.',
        downTemplate: 'Download template',
        import: 'Import',
        male: 'Male',
        female: 'Female',
        desc: 'Description',
        coursewareLibrary: 'Courseware Library',
        producer: 'Prepared By',
        productionDate: 'Prepared On',
        modify: 'Edit',
        making: 'Prepare',
        resourceName: 'Resource name',
        problemNo: 'Question No.',
        right: 'True',
        wrong: 'False',
        error: 'Error',
        notAvailable: 'Not available',
        detail: 'Details',
        option: 'Options',
        check: 'Select',
        noticeHoverTitle: 'Message notification',
        noticeTitle: 'Message Notification',
        noticeNone: 'No notice',
        noticeClear: 'Clear notification',
        upTrend: 'Upload Trend (Last 1 Month)',
        trainAnalyse: 'Training Task Analysis (Last 1 Month)',
        quickEntry: 'Quick entry',
        seeMore: 'More',
        trainFinish: 'Training Plan Completion Status',
        toEnd: 'Remaining',
        day: 'Day',
        hour: 'Hour',
        viewDetail: 'View Details',
        recentWeek: 'Last 1 Week',
        miles: 'miles',
        open: 'Open',
        exam: 'Exam',
        practice: 'Practice',
        learn: 'Learning',
        completeTime: 'Completion time',
        notYet: 'Not yet',
        notGet: 'None',
        lookForward: 'Please look forward to ...',
        yearTime: 'Year',
        employmentDate: 'EmploymentDate',
        imageLearn:'Image learned',
        studyTime:'Total study time',
        learningStatistics:'Learning statistics',
        exportLearnStats:'Export learning statistics',
        clear:'Clear',
        moment: 'a moment ago',
        yearAgo: 'year(s) ago',
        monthAgo: 'month(s) ago',
        weekAgo: 'week(s) ago',
        dayAgo: 'day(s) ago',
        hourAgo: 'hour(s) ago',
        minuteAgo: 'minute(s) ago',
        month: 'Month',
        unset: 'Unset',
        enabled: 'Enabled',
        fiscan: 'Fiscan',
    },
    tip: {
        select: 'Please select',
        input: 'Please enter content',
        name: 'Please enter the name',
        sysName: 'Please enter the system name',
        sysEnName: 'Please enter the English name of the system',
        sysShortName: 'Please enter the system short name',
        sysVersion: 'Please enter the system version',
        knowledgePoint: 'Select knowledge point',
        operatorLevel: 'Select the applicable level',
        belong: 'Please select the organization',
        trainingType: 'Please select training category',
        examType: 'Please select the test mode',
        orgName: 'Please enter the organization name',
        userSearch: 'Enter name,employee ID',
        userSearchPlus: 'Enter name,employee ID,mobile',
        username: 'Please enter the user name',
        usernameOrNo: 'Enter username or employee ID',
        usernameOrAccount: 'Input user name or NO.',
        idNo: 'Please enter employee ID',
        occupation: 'Please select the identity type',
        grade: 'Please select the skill',
        position: 'Please select position',
        gender: 'Please select the gender',
        birthday: 'Please select the date of birth',
        idCardNo: 'Please select the identity card No.',
        education: 'Select education background',
        path: 'Please enter the path',
        icon: 'Please enter the icon class name',
        NO: 'Please enter the SN',
        remark: 'Please enter the comments',
        time: 'Please select time',
        date: 'Please select date',
        datetime: 'Please select the date and time',
        startTime: 'Please select start time',
        endTime: 'Please select end time',
        employmentDate: 'Please select employment time',
        reason: 'Please select a reason',
        courseName: 'Enter the courseware name',
        producer: 'Please input the producer',
        courseType: 'Please select the type of courseware',
        hours: 'Please enter the class hours',
        credits: 'Please enter the credit',
        addImg: 'Please enter the image',
        problemNo: 'Enter question No.',
        creator: 'Please enter the creator',
        difficulty: 'Select the difficulty degree',
        titleDesc: 'Enter the question description',
        chooseRightAnswer: 'Please select the correct answer',
        optionDesc: 'Please enter the option description',
        paperName: 'Please enter the paper name',
        paperGroupType: 'Please select the test paper compilation mode',
        passLine: 'Please enter the pass line',
        questionScore: 'Please enter the marks of the question',
        paperType: 'Please enter the paper type',
        paperForm: 'Please enter the paper form',
        perspective: 'Please select the view',
        account: 'Please enter the account',
        trainerName: 'Please enter a trainer name',
        transcriptTitle: 'Please enter the transcript name',
        word: 'Please enter text',
        title: 'Please enter a title',
        option: 'Please enter option content',
        trainName: 'Please enter training plan name',
        oldPwd: 'Please enter the old password',
        newPwd: 'Please enter the new password',
        confirmPwd: 'Please enter new password again',
        mobile: 'Please enter mobile number',
        code: 'Please enter verification code',
        untie: 'Please enter the verification code sent to your mobile phone to unbind',
        chooseGroupType: "Temporarily, the CT type does not support fast test paper compilation. Please re-select a test paper compilation mode",
        txtContent: 'Content area...',
        resName: 'Please enter the resource name',
        imgUploadMaxSize: 'Image size cannot exceed {0}M',
        fileUploadMaxSize: 'File size cannot exceed {0}M',
        fileExceedTip: 'Select at most {0} files, {1} files are selected at this time, {2} files are selected totally',
        chooseOrgFirst: 'Please select the organization first',
        queryOrg: 'Query organization',
        chooseDueDate: 'Please select a deadline',
        chooseTopicSource: 'Please select question source',
        knowTagTip: 'Please enter the knowledge tag',
        uploader: 'Please enter the uploader',
        knowTypeTip: 'Please select the knowledge type',
        knowNameTip: 'Please enter the knowledge name',
        knowDescTip: 'Please enter the knowledge description',
        tipStart: 'Please select start time',
        tipEnd: 'Please select end time',
        type: 'Please select',
    },
    rule: {
        lengthBetween: 'The length supports {0}–{1} characters',
        maxLength: 'The length cannot exceed {0} characters',
        idCardNo: 'Please enter a valid ID number',
        required: 'This field is required',
        int: 'Value cannot be decimals',
        time: 'The time shall be later than the current time',
        pwd: 'The password shall be a combination of 12–20 digits, letters, and special characters _-#@&?*^=!.$%',
        pwdError: 'Do not meet the password rules, please re-fill',
        mobileNotExist: 'The phone number does not exist！',
        mobileHasBound: 'The number has been bound to another account',
        modifyPwd:'Please change the password!',
        codeError: 'Special characters only support _-#@&?*^=!.$%',
    },
    system: {
        sysName: 'System Name',
        sysEnName: 'English Name of System',
        sysShortName: 'System Abbreviation',
        sysVersion: 'System Version',
        sysLogo: 'System logo',
        editSysLogo: 'Change system logo',
        addOrg: 'Add organization',
        orgDetail: 'Organization Details',
        orgName: 'Organization Name',
        orgDesc: 'Organization Description',
        addUser: 'Add User',
        importUser: 'Import User',
        editUser: 'Modify User',
        cycleUser: 'Retrieve User',
        recoverUser: 'Retrieve User',
        deleteUser: 'Delete User',
        modifyRole: 'Modify Role',
        manageRole: 'Manage Role',
        addRole: 'Add Role',
        delRole: 'Delete Role',
        resetPwd: 'Reset Password',
        unselected: 'Not selected',
        selected: 'Selected',
        changeAvatar: 'Change my avatar',
        userProfile: 'User profiles',
        trainRecord: 'Training Record',
        skillRecord: 'Skill Authentication',
        result: 'Result',
        certificateName: 'Certificate Name',
        certAdd: 'Add Certificate',
        certDetail: 'Certificate DetailS',
        certificateNo: 'Certificate No.',
        level: 'Rating',
        operateScore: 'Operation score',
        theoryScore: 'Theoretical score',
        releaseDate: 'Issue Date',
        editMenu: 'Modify Menu',
        addMenu: 'Add Menu',
        addSubmenu: 'Add Sub-menu',
        parent: 'Upper Level',
        path: 'Path',
        icon: 'Icon',
        roleName: 'Role',
        manageMember: 'Configure Member',
        manageMenu: 'Configure Menus',
        allMembers: 'All members',
        memberList: 'Member List',
        selectedMember: 'Selected Person',
        theoryKnowledge: 'Theoretical Knowledge Point',
        imageKnowledge: 'Image Knowledge Point',
        remark: 'Comments',
        exportUser: 'Export User (by Above Filter Conditions)',
        preJobApproval: 'Pre-job approval',
        capabilityAnalyse: 'Capability analysis',
        enabled: 'enabled',
        disabled: 'disabled',
        projectType: 'Project type',
        importOrg: 'Import organization',
        exportOrg: 'Export organization',
        move: 'move'
    },
    user: {
        basicInfo: 'Basic Information',
        postInfo: 'Job Information',
        experienceInfo: 'Work Experience',
        trainInfo: 'Training Record',
        qualityInfo: 'Quality Control Record',
        rewardInfo: 'Reward and punishment information',
        modifyInfo: 'Modify record',
        importDiploma: 'Import diploma photos',
        exportBasicInfo: 'Export basic information',
        exportExtendInfo: 'Export details',
        userImportTemplate: 'User import template',
        userBasicImportTemplate: 'User Basic Information Template',
        userExtendImportTemplate: 'User details template',
        zipImportTemplate: 'Compressed package template',
        clickToDownload: 'Click to download',
        chooseToDownload: 'Choose one of the following templates to download:',
        startImport: 'Start upload',
        unbind: 'Unbound',
        bindTip: 'Need to bind by user',
        nation: 'Nation',
        hometown: 'Hometown',
        currentAddress: 'Residence address',
        graduationSchool: 'Graduated school',
        graduationDate: 'Graduation date',
        graduationDateTip: 'Select graduation date',
        jobDate: 'Date of starting to work',
        jobDateTip: 'Select date of starting to work',
        securityCheckJobDate: 'Date of work for security inspection',
        securityCheckJobDateTip: 'Select date of work for security inspection',
        employmentDate: 'Employment date',
        employmentDateTip: 'Select employment date',
        diplomaPicture: 'Diploma and degree photos',
        downloadFile: 'Download attachments',
        duty: 'Position',
        jobTitle: 'Job title',
        backgroundReview: 'Background review',
        certTip: 'Need to add a certificate for this user in "Certificate Management"',
        startEndTime: 'Start and end time',
        companyName: 'Company name',
        addWorkExperience: 'New work experience',
        editWorkExperience: 'Edit work experience',
        addQuality: 'Add quality control records',
        editQuality: 'Edit quality control records',
        cause: 'Cause',
        dealResult: 'Result',
        addReward: 'Add reward and punishment information',
        editReward: 'Edit reward and punishment information',
        rewardDetail: 'Reward and punishment detail',
        punish: 'Punish',
        reward: 'Reward',
        module: 'Module',
        ledgerRecord: 'Ledger Record',
    },
    train: {
        name: 'Training Name',
        type: 'Training Category',
        percent: 'Progress',
        memberNum: 'Trainee Quantity',
        site: 'Training Venue',
        classHour: 'Class Hour',
        classScore: 'Class Score',
        content: 'Content',
        time: 'Training Time',
        checkInTime: 'Check-in time',
        preTime: 'Pre-time',
        dueTime: 'Deadline',
        addOnlineTrain: 'Add online training',
        addOfflineTrain: 'Add offline training',
        associatePaper: 'Associate Questionnaire',
        choosePaper: 'Select Questionnaire',
        paperName: 'Questionnaire Survey Name',
        surveyName: 'Survey Name',
        confirmPublish: 'Are you sure to publish?',
        newOnlineTraining: 'New online training',
        newOfflineTraining: 'New offline training',
        editTraining: 'Modify Training',
        basicInfo: 'Basic Information',
        trainees: 'Trainees',
        courseSystem: 'Course System',
        chooseCourse: 'Select Course',
        chooseTestPaper: 'Select Test Paper',
        chooseMockPaper: 'Select Mock paper',
        chooseTip: 'Please add processes',
        testPeriod: 'Please enter the test duration',
        editPaperTip: 'Please edit the test paper',
        addSuccess: 'Successfully added the training plan!',
        editSuccess: 'Successfully modified the training plan!',
        trainDetail: 'Training detail',
        trainTrace: 'Training Completion Status',
        planDetail: 'Training Record Details',
        progress: 'Current Progress',
        progressNow: 'Completion Progress',
        delTrainee: 'Remove this trainee',
        delTraineeConfirm: 'Are you sure to move {0} from the training plan?',
        // addTrainee: 'Add trainee',
        addTrainee: 'Add people',
        reason: 'Reason',
        absentReason: 'Absence Reason',
        casualLeave: 'Private Affair Leave',
        sickLeave: 'Sick Leave',
        annualLeave: 'Annual Leave',
        parentalLeave: 'Maternity Leave',
        maternityLeave: 'Pregnancy Leave',
        paternityLeave: 'Paternity Leave',
        passiveFinish: 'Pregnancy Leave',
        credit: 'Credit',
        hour: 'Class hour',
        times: 'Times',
        resitTimes: 'Times',
        qrCode: 'QRCode',
        enlarge: 'Expand/Collapse table',
        endDate: 'End date',
        trainPlan: 'Training',
        signArea: 'Check-in area',
        signPoint: 'Check-in location',
        userStatus: 'User status',
        trainingMode: 'Training mode',
        currentOrg: 'Currently selected organization',
        clickOrgFirst: 'Please click the organization on the left first, and select a deadline',
        checkAllMembers: 'Do the following for all members',
        advancedSettings: 'Advanced Settings',
        advancedAccount: 'Please enter the student account number or employee ID, separate by spaces or line breaks',
        advancedMaxError: 'Please do not exceed 1000 accounts!',
        extendEndTime: 'Extend end time',
        extendTip1: 'End time cannot be less than the current date',
        extendTip2: 'Cancel the end time setting and will extend the training program indefinitely',
        extendRule: 'Rules',
        clonePlan: 'Clone training',
        cloneTip1: 'Trainees of the training course will not be cloned',
        cloneTip2: 'If the training name is not specified, the name of the cloned training course will be used.',
        cloneSuccess: 'Clone successfully!',
        group: 'Group',
        groupManage: 'Group management',
        groupName: 'Group name',
        groupAdd: 'Add group',
        groupEdit: 'Edit group',
        pushMessage: 'Push notifications',
        surePushMessage: 'Are you sure this training plan will be pushed？',
        pushSuccess: 'Push successfully！'
    },
    course: {
        course: 'Courseware',
        name: 'Courseware Name',
        type: 'Courseware Type',
        sectionCannotDisplay: 'Temporarily, resources of this chapter are not presented',
        theoryCourseware: 'Theoretical Courseware',
        chapter: 'Chapter',
        theChapter: 'Chapter {0}', // 重点翻译
        viewing: 'Viewing',
        myCourse: 'My Courseware',
        theoryCoursewareMake: 'Prepare Theoretical Courseware',
        theoryCoursewareEdit: 'Edit Theoretical Courseware',
        imageCoursewareMake: 'Prepare Image Courseware',
        imageCoursewareEdit: 'Edit Image Courseware',
        imageCourseware: 'Image courseware',
        addBaseInfo: 'Add Basic Information',
        addChapter: 'Add Chapter',
        addImage: 'Add Image',
        courseCover: 'Courseware Cover',
        addCover: 'Add Cover',
        deleteCover: 'Delete Cover',
        coverTip: 'Note: The size of cover image cannot exceed {0} MB.',
        coverTooBigMsg: 'The size of uploaded cover image cannot exceed 2 MB!',
        courseDesc: 'Courseware Description',
        courseNoImg: 'The current courseware has no image, click the button to add',
        imageName: 'Image Name',
        addImageDesc: 'Add Image Description',
        addImageDescInfo: 'Please add the image description',
        courseMakeSuccess: 'Successfully prepared the courseware!',
        curriculumSystem: 'Course System',
        chapterTitle: 'Please enter the chapter title',
        sectionTitle: 'Please enter the section title',
        resourceSelection: 'Select Resource',
        fileUpload: 'Upload File',
        fastForward: 'Fast-forward',
        noFastForward: 'Non-fast-forward',
        learningTime: 'Learning Duration',
        terminateUpload: 'Terminate Uploading',
        imageUpload: 'Upload Image',
        documentUpload: 'Upload Document',
        videoUpload: 'Upload Video',
        audioUpload: 'Upload Audio',
        fileUploadFail: 'Failed to upload the file. Please upload again',
        courseEditSuccess: 'Successfully modified the courseware!',
        marquee: 'Whether to open marquee',
        marqueeText: 'Please enter marquee content',
        min: 'min',
        addTip: 'Note: Click the chapter name input box and press Enter to add the chapter.',
        sectionDes: 'Please input the section description'
    },
    topic: {
        name: 'Question Name',
        examPaperLibrary: 'Test Question Library',
        detailView: 'Detail view',
        listView: 'List view',
        useTimes: 'Sorting by Use Times',
        rightRateSort: 'Sorting by Accuracy Rate',
        rightRate: 'Accuracy Rate',
        default: 'Default Sorting',
        papersAssembleTimes: 'Group Times',
        papersTimesSort: 'Group Times Sorting',
        papersAssembled: 'Grouped Times',
        answerAnalysis: 'Answer Analysis',
        imageDesc: 'Image description',
        questionDesc: 'Question description',
        myTopic: 'My Questions',
        addTopic: 'Add Question',
        editTopic: 'Edit Question',
        optionDesc: 'Option Description',
        rightOption: 'Correct Option',
        addOrEditAnalyse: 'Add/Modify Answer Analysis',
        simulatedBag: 'Simulated Baggage',
        emptyPacket: 'Empty Baggage',
        dangerous: 'Dangerous',
        chooseImage: 'Select Image',
        addTopicDesc: 'Click and add question analysis',
        insertTip: 'Insert TIP',
        editSaveSuccess: 'Successfully edited and saved!',
        passLine: 'Pass Line',
        mockPassLine: 'Pass Line',
        leastOne: 'Please select at least one question',
        addTopicByPic: 'Import pictures to generate questions',
        excelDown: 'Download Excel Template',
        excelImport: 'Import Excel',
        wordDown: 'Download Word Template',
        wordImport: 'Import Word',
        tipAdjust: 'Tip adjust',
        tipAdjustPanel: 'Tip adjustment control panel',
        zoom: 'Zoom',
        rotate: 'Rotate',
        physicalMap: 'Photo',
        attention: 'Attention',
        tipInsertAttention1: '1. Please do not scale or rotate the Tip inserted in the double-view package',
        tipInsertAttention2: '2. If the Tip image exceeds the bag image during zooming or rotation, manually drag and adjust',
        tipInsertAttention3: '3. Tip zoom please choose a reasonable range, try to match the actual situation',
        answerLabelType: 'Answer Label Type',
        clickUpload: 'Upload'
    },
    paper: {
        paper: 'Test paper',
        myPaper: 'My Test Paper',
        theoryPaper: 'Theoretical Test Paper',
        theoryPaperMake: 'Prepare Theoretical Test Paper',
        theoryPaperEdit: 'Edit Theoretical Test Paper',
        imagePaper: 'Image Test Paper',
        imagePaperMake: 'Prepare Image Test Paper',
        imagePaperEdit: 'Edit Image Test Paper',
        name: 'Test Paper Name',
        type: 'Test Paper Type',
        form: 'Test Paper Form',
        paperMethod: 'Test Paper Compilation Mode',
        testPeriod: 'Test Duration (Minute)',
        publishTime: 'Answer Release Time',
        publishTimeTip: 'If not specified, the answer will be immediately released after you finish the test paper.',
        allowReview: 'Allow to check the answer',
        allowResit: 'Resit examinations',
        allowResitTimes: 'Number of resit',
        resatTimes: 'Times of resat',
        keyResit:'Resit',
        resitSuccess: 'Resit successfully！',
        leaveTimes: 'Times of leave',
        disorder: 'Disorder',
        faceMatching: 'Face matching',
        photoDuration: 'Invigilator photo frequency',
        secondPerTime: 'sec/time',
        questionType: 'Question type',
        single: 'Single-selection Question',
        multiple: 'Multi-selection Question',
        trueOrFalse: 'True or False',
        matching: 'Matching Question',
        graphic: 'Graphic Question',
        buildupSmart: 'Smart Test Paper Compilation',
        buildupChoose: 'Select Question for Compilation',
        buildupImport: 'Import Question for Compilation',
        passScore: 'Ruled Score',
        passingMark: 'Ruled Score',
        totalScore: 'Total Score',
        paperLibrary: 'Test Paper Library',
        paperScore: 'Test Paper Score',
        editPaper: 'Edit Question',
        startPaper: 'Start Test Paper Compilation',
        randomGenPaper: 'Randomly select questions from the question library and generate a test paper according to the preset compilation conditions.',
        chooseGenPaper: 'Select desired questions to compile a test paper.',
        importGenPaper: 'Import Word, Excel templates, or enter them manually to quickly generate exam papers.',
        chooseImportType: 'Select the import mode',
        wordImport: 'Import Word',
        wordUpload: 'Upload Word',
        excelImport: 'Import Excel',
        excelUpload: 'Upload Excel',
        clickBtnAddTopic: 'The current test paper has no questions. Click the button to add questions',
        addTopic: 'Add Question',
        totalQuestions: 'Total Number',
        totalScores: 'Total Score',
        points: '',
        reimport: 'Re-import',
        previewPaper: 'Preview',
        savePaper: 'Save',
        answer: 'Answer',
        analysis: 'Analysis',
        keyQuestion: 'Key question',
        keyQuestionAccuracy: 'Accuracy Rate of Key Questions',
        backToTop: 'Top',
        chooseTopic: 'Select Question',
        topicSource: 'Question Source',
        source: 'Source',
        editPaperSuccess: 'Successfully modified the test paper',
        theoryPaperMakeSuccess: 'Successfully prepared the theoretical test paper',
        difficultDistribution: 'Difficulty Degree',
        simple: 'Simple',
        medium: 'Medium',
        hard: 'Difficult',
        questionQuantity: 'Quantity',
        scorePerQuestion: 'Mark per Question',
        singleTotalNum: 'Single-selection question ({0})',
        multipleTotalNum: 'Multi-selection question ({0})',
        judgeTotalNum: 'True or False question ({0})',
        knowledgeTotalNum: 'Knowledge point( {0} )',
        emptyPacketTotalNum: 'Empty package( {0} )',
        otherTotalNum: 'Others( {0} )',
        selectYourTopic: 'Select {0} question(s)',
        paperNumGtOne: 'The test paper shall contain at least one question',
        paperNeddIncludeOneKP: 'The test paper shall contain the question of at least one knowledge point',
        smartGroupSuccess: 'Successfully implemented smart test paper compilation',
        imageTopic: 'Image question',
        dao: '',
        eachTopic: 'Per question',
        setKeyTopic: 'Set Key Questions',
        accuracyRate: 'Accuracy Rate',
        buildupFast: 'Rapid buildup',
        tipGenPaper: 'Automatically insert TIP and quickly generate test paper',
        safeBag: 'Safe',
        selectKPTip: 'Automatically insert the TIP image to rapidly generate the test paper',
        ge: '',
        emptyNum: 'Empty baggage',
        dangerNum: 'Dangerous',
        simulatedNum: 'Simulated baggage',
        warnEmpty: 'Please enter the quantity of safe baggage',
        showAnswerAfterExam: 'Release after Test Completion',
        mock: 'Mock Test',
        mockTimes: 'Number of Mock Tests',
        chooseKpFirst: 'Please select knowledge point first',
        exportPaper: 'Export Test Paper',
        imgSourceTip: 'Please select the source of images'
    },
    // 全屏的考试/练习页
    exam: {
        totalCount: 'Total count',
        question: 'Questions',
        min: 'Minutes',
        score: 'Score',
        period: 'Test Duration',
        answerSheet: 'Answer Sheet',
        singleMode: 'Single-question Mode',
        multiMode: 'Multi-question Mode',
        correct: 'Correct',
        incorrect: 'Incorrect',
        answered: 'Answered',
        blank: 'Blank',
        viewAnswer: 'View Answer',
        prev: 'Previous',
        next: 'Next',
        submit: 'Submit Paper',
        practiceTitle: 'Theoretical Practice',
        loading: 'Loading...',
        result: 'Test Result',
        practiceResult: 'Practice Results',
        paperCount: 'This test paper contains totally',

    },
    //图库、资源管理
    res: {
        imgName: 'Image Name',
        imgType: 'Image Type',
        imgDesc: 'Image Description',
        perspective: 'View',
        singleView: 'Single View',
        doubleView: 'Double View',
        sideView: 'Double View',
        imgOrigin: 'Image Origin',
        file: 'File',
        fileView: 'File view',
        listView: 'List view',
        viewCT: 'View CT',
        viewDR: 'View DR',
        lastFile: 'Previous File',
        nextFile: 'Next File',
        editImg: 'Modify Image info',
        resName: 'Resource Name',
        resType: 'Resource Category',
        checkAll: 'Select All',
        cancelCheckAll: 'Cancel all',
        allFiles: 'All files',
        upload: 'Upload',
        uploadTime: 'Upload Time',
        rename: 'Rename',
        progress: 'Executing...',
        renameSuccess: 'Renamed successfully!',
        newFolder: 'New Folder',
        folderNameTip: 'Please enter the folder name',
        folderNameIs: 'Name of the folder:',
        newFolderSuccess: 'Created successfully!',
        uploadStep: 'Upload steps',
        success: 'Success',
        error: 'Error',
        uploading: 'Uploading',
        paused: 'Paused',
        waiting: 'Waiting',
        delete: 'Delete',
        fileList: 'File List',
        chooseFile: 'Select File',
        expand: 'Expand',
        fold: 'Collapse',
        noUploadFile: 'No file to upload',
        checkMD5: 'Check MD5',
        transcoding: 'Transcoding',
        merging: 'Merging',
        uploadFail: 'Failed to upload',
        copyTo: 'Copy to',
        moveTo: 'Move to',
        refresh: 'Refresh',
        fileTotal: '{0} files total',
        fileSize: 'File size',
        playAudio: 'Play audio',
        syncToLibrary: 'Synchronize to image library',
        bag: 'Bag',
        editImage: 'Edit image',
        isTip: 'Tip or not',
        isDeleteAfterTB: 'Whether or not to delete',
        synchSuccess: 'Synchronize successfully!',
        deleteMulti: 'Are you sure to delete this {0} files？',
        fiscanImage: 'Fiscan image statistics detail',
        nuctechImage: 'Nuctech image statistics detail',
        copy: 'Copy images',
        move: 'Move images',
        selected: 'Selected {0} items',
        standardLib: 'Standard',
        userLib: 'User',
        addNode: 'Add Node',
        shareFrom: 'Share from {share}',
        editNode: 'Edit Node',
        addChildNode: 'Add child node',
        nodeName: 'Node Name',
        nodeType: 'Node Type',
        folder: 'Folder',
        imgFile: 'Image Folder',
        selectImgFile: 'Please select image file',
        selectMember: 'Select member',
        moveSuccess: 'Moved successfully!',
        copySuccess: 'Copyed successfully!',
        shareSuccess: 'Shared successfully!',
        sureDelFile: 'Are you sure delete {file}?',
        sureDelImgFile: 'Are you sure to delete {file}? If deleted, the images contained in the images folder will also be deleted',
        currentCheckNode: 'Image Position',
        checkNodeTip: 'Please click the image folder on the left',
        addKnowledge: 'Add Knowledge',
        knowName: 'Knowledge Name',
        knowType: 'Knowledge Type',
        knowTag: 'Knowledge Tag',
        knowDesc: 'Knowledge Description',
        pageViews: 'Views',
        comments: 'Comments',
        likes: 'Likes',
        allVisible: 'Visible To All',
        someVisible: 'Visible To Some',
        uploader: 'Uploader',
        visibleRange: 'Set Visible Range',
        knowTagTip: 'Tags are easy to find and manage tools, please separate multiple tags with commas',
        visiblePerson: 'Visible personnel',
        updateSystemTree: 'Update System Image Library',
        noAccessToDelete: "No permission to delete all selected images",
        filterDelete: "It will automatically filter out {0} images, which you don't have access to delete",
        tipLib: 'Tip Library',
        bagLib: 'Bag Library',

    },
    cert: {
        holder: 'Certificate Holder',
        type: 'Certificate Type',
        date: 'Date',
        number: 'No.',
        issueDate: 'Issue Data',
        reviewDate: 'Review Data',
        retrainDate: 'Re-training Date',
        releaseDate: 'Date of Certificate Issue',
        obtainDate: 'Date of Certificate Retrieval',
        addCert: 'Add Certificate',
        downCertTemp: 'Download Certificate Template',
        upLoadCertTemp: 'Import Certificate',
        upLoadCertPic: 'Import Certificate Picture',
        exportCertTemp: 'Export Certificate',
        downCertRetrain: 'Download Re-training Template',
        upLoadCertRetrain: 'Import Re-training Record',
        exportCertRetrain: 'Export Re-training Record',
        editCert: 'Edit Certificate',
        dangerCert: 'Dangerous Item Certificate',
        proCert: 'Vocational Qualification Certificate',
        juniorProCert: 'Beginner-level Vocational Qualification Certificate',
        IntermediateProCert: 'Intermediate-level Vocational Qualification Certificate',
        seniorProCert: 'Advanced-level Vocational Qualification Certificate',
        technicianProCert: 'Technician Vocational Qualification Certificate',
        technicianProPlusCert: 'Technician Vocational Qualification Certificate',
        certManage: 'Certificate Management',
        certAddTip: 'Add a certificate for this person',
        certAddTip_1: 'Please add a certificate for this person on the left',
        howToTip: 'Please select a certificate holder on the left and add a certificate',
        selectHolderTip: 'Please select the certificate holder',
        certInfo: 'Certificate Details',
        certName: 'Certificate Name',
        certNum: 'Certificate No.',
        theoryScore: 'Theory Score',
        operationScore: 'Operation Score',
        gradeName: 'Rated Score',
        retrain: 'Re-training',
        retrainRecord: 'Re-training Record',
        retrainGrade: 'Re-training Score',
        obtainCert: 'Get Certificate',
        trainSubject: 'Training Course',
        trainInstitution: 'Training Organization',
        trainerName: 'Trainer Name',
        personType: 'Staff Category',
        trainConclusion: 'Test Conclusion',
        qualified: 'Qualified',
        good: 'Good',
        excellent: 'Excellent',
        addRecord: 'Add record',
        editRecord: 'Edit record',
        selectUser: 'Select user',
        junior: 'J',
        Intermediate: 'I',
        senior: 'S',
        technician: 'T',
    },
    count: {
        quantity: 'Quantity',
        certMember: 'Certificate Holder Detail',
        viewType: 'View Type',
        singleView: 'Single View',
        dualView: 'Dual View',
        frequency: 'Use Times',
        resType: 'Resource Type',
        uploadRank: 'Upload Count Ranking',
        uploadNum: 'Upload Count',
        courseNum: 'Courseware Quantity',
        theory: 'Theory',
        topicType: 'Question Type',
        topicDetail: 'Question Detail',
        topicNo: 'Question No.',
        examName: 'Test Name',
        examDuration: 'Test Duration',
        score: 'Score',
        peopleNum: 'Number of Persons',
        totalPeopleNum: 'Number of Persons',
        passRate: 'Pass Rate',
        passScore: 'Ruled Score',
        averageScore: 'Average Score',
        lowest: 'Lowest Score',
        highest: 'Highest Score',
        examAttend: 'Expected Attendance',
        attend: 'Attendance',
        examRealAttend: 'Actually Attendance',
        absent: 'Absent',
        examAbsence: 'Absence',
        passed: 'Passed',
        examPassNum: 'Qualified',
        failed: 'Unqualified',
        examFailNum: 'Unqualified',
        countAnalysis: 'Statistics Analysis',
        paperScoreStatistic: 'Score Statistics',
        examDetailTitle: 'Test Details Statistics Graph',
        wrongRateTitle: 'Error Rate Statistics',
        rightNum: 'Correct Number',
        wrongNum: 'Incorrect Number',
        wrongRate: 'Error Rate',
        scoreRank: 'Rank',
        transcript: 'Report',
        exportStuDetail: 'Export Answer Details',
        exportTranscript: 'Export Report',
        exportOffline: 'Export Training List',
        print: 'Print',
        printReview: 'Print Preview',
        exportDate: 'Export Date',
        timeConsume: 'Cost Time',
        submitTime: 'Submitted On',
        ranking: 'Ranking',
        rankStatisticsTitle: 'Score Ranking Statistics',
        rankRangeTitle: 'Score Distribution Statistics',
        feedback: 'Survey Feedback',
        trainDetailTitle: 'Training Details Statistics',
        numStatistics: 'Quantity Statistics',
        studyDuration: 'Learning Duration',
        studyTime: 'Learning time',
        studyNum: 'Total Questions Learned',
        min: 'Minute',
        s: 'Second',
        personalStudyTitle: 'Individual Learning Statistics',
        finish: 'Completed',
        unfinish: 'Uncompleted',
        notStart: 'Not started',
        processing: 'Ongoing',
        absence: 'Absent',
        recover: 'Restore',
        registered: 'registered',
        normal: 'normal',
        late: 'late',
        error: 'error',
        studentStatus: 'Status',
        knowErrorRate: 'Incorrect rate',
        knowErrorRateStat: 'Knowledge incorrect rate statistics',
    },
    survey: {
        name: 'Survey Name',
        add: 'Add Survey Questionnaire',
        edit: 'Edit Survey Questionnaire',
        desc: 'Survey Description',
        topic: 'Survey Subject',
        addOption: 'Add option',
        addTitleTip: 'Click to add subject',
        subjective: 'Subjective Question',
        star1: 'Very dissatisfied',
        star2: 'Dissatisfied',
        star3: 'General',
        star4: 'Satisfied',
        star5: 'Very satisfied',
        responseNum: 'Number of Respondents',
        percentage: 'Percentage',
        detail: 'Questionnaire detail',
        statisticsTitle: 'Training Questionnaire Statistics',
        publisher: 'Publisher',
        validNum: 'Number of Valid Questionnaires',
        satisfaction: 'Overall Satisfaction',
        proportion: 'Proportion',
        synthesis: 'Comprehensive',
        appraised: 'Not evaluated (0)',
        average: 'Average Score:'
    },
    questionnaire: {
        name: 'Questionnaire Name',
        add: 'Add Questionnaire',
        edit: 'Edit Questionnaire',
        desc: 'Questionnaire Description',
        topic: 'Questionnaire Topics',
        starTopic: 'Score Topic',
        startSurvey: 'Launch an investigation',
        peopleNum: 'Number of Persons',
        defaultReport: 'Default report',
        replyStatistics: 'Answer statistics',
        NO: 'NO {0}',
        filterEmpty: 'Filter empty options',
        replyTime: 'Answer time',
        replyTxt: 'Answer text',
        viewPaper: 'View paper',
        startSuccess: 'Launched successfully!',
        maxLimit: 'Select up to {0} items',
        open: 'Open Questionnaire',
        close: 'Close Questionnaire',
        export: 'Export Questionnaire',
        confirmOpen: 'Are you sure to open the questionnaire?',
        confirmClose: 'Are you sure to close the questionnaire?',
        successOpen: 'Open successfully!',
        successClose: 'Close successfully!',
    },
    // 学员模块
    stu: {
        unfinished: 'Uncompleted',
        finished: 'Completed',
        studyProgress: 'Learning progress',
        viewCourse: 'View Courseware',
        enterStudy: 'Start learning',
        continueStudy: 'Continue the Learning',
        viewPaper: 'View Test Paper',
        enterExam: 'Start Test',
        continueExam: 'Continue the Test',
        enterMock: 'Start Mock Test',
        startResit: 'Start resitting',
        resitStatus: 'Resit status',
        resat: 'Have resat',
        allowResit: 'Allow resit',
        loadingExamTip: 'Loading the test papers...',
        serverError: 'The server encounters an error',
        loadPaperError: 'Failed to load test paper data！',
        topicNum: 'Quantity of Questions',
        startPractice: 'Start to Practice',
        startStudy: 'Start to Learn',
        timeSetting: 'Time settings',
        set: 'Set',
        notSet: 'Not set',
        singleTopic: 'Single Question',
        wholePaper: 'Entire Test Paper',
        practiceMode: 'Practice Mode',
        quickJudge: 'Rapid Analysis',
        markLocation: 'Mark Position',
        markLocationAndJudge: 'Mark Position and Select Type',
        pass: 'Pass',
        passed: 'Passed',
        failed: 'Not passed',
        passRate: 'Pass Rate',
        theoryPractice: 'Theoretical Practice',
        imgPractice: 'Image Practice',
        practiceDate: 'Practice Date',
        timeoutNum: 'Number of Expired Questions',
        trainTask: 'Training Task',
        personal: 'Personal statistics',
        trainNum: 'Training Quantity',
        testNum: 'Test Quantity',
        exciseNum: 'Practice Quantity',
        imageNum: 'Image Analysis Quantity',
        errorStatistics: 'Error Answer Statistics ',
        isPass: 'Pass Status',
        testPass: 'Test Pass Status ',
        courseStudy: 'Courseware learning',
        imageAbility: 'Image Analysis Capability Analysis',
        theoryKP: 'Theoretical Knowledge Point',
        imageKP: 'Image Knowledge Point',
        taskName: 'Task Name',
        intoTask: 'Enter Task',
        imgPracticeTip1: '1. You can use the shortcut buttons [>] and [?] to identify the passed or non-passed images in the fast identification mode.',
        imgPracticeTip2: '2. In non-fast identification mode, you must manually mark the suspicious items for dangerous goods images.',
        imgPracticeTip3: '3. If the answers are set not editable, you can identify only activated images (with blinking dots).',
        imgPracticeTip4: '4. The system keeps only recent images rather than all the historical images during TIP. For images that are deleted, you cannot change the answers.',
        imgPracticeTip5: '5. You can press the shortcut buttons (1, 2, and 3) to change the speed, press the shortcut buttons (z, x, and c) twice to change the mark frame size, and press the Space button to pause or start the operation.',
        walkingPictureSetting: 'WTIP Configuration',
        answerCanModify: 'The answer is editable',
        answerCannotModify: 'The answer is not editable',
        slow: 'Slow',
        normal: 'Normal',
        fast: 'Fast',
        suspectColor: 'Frame color',
        speed: 'Speed',
        pracitceNote: 'Precautions for Practice',
        theoryAndImgPractice: 'Theoretical and Image Practice',
        continuePractice: 'Continue Practicing',
        newPractice: 'New practice',
        unsubmitPracticeTip: 'The current practice has not been submitted. Do you want to continue the current practice?',
        imgStudyMenu: 'Image Study',
        imgPracticeMenu: 'Static Practice',
        trackPracticeMenu: 'Simulation Practice',
        submitDate: 'Submission date',
        images: 'Images',
        resultpf: 'Result(P/F)',
        historyMockPaper: 'History tests',
        enterExamTip: 'Once the test begins, dropping out may result in no grades. Please prepare for the exam.',
        creditsEarned:'Credits earned',
        totalCredit: 'Total credits',
        monthCredit: 'Credits of the month',
        allRank: 'Total Rank',
        orgRank: 'Organization Rank',
        creditDetail: 'Credit detail',
        watchCreditDetail: 'View Credit detail',
        rankList: 'Rank List',
        watchRankList: 'View Rank List',
        myCreditRecord: 'My credit record',
        rank: 'Rank',
        noRank: 'No rank'
    },
    prejob: {
        colorBlind: 'Color Blindness and Weakness',
        colorSensitive: 'Color Sensitivity',
        spatialIntelligence: 'Spatial Intelligence',
        basicKnowledge: 'Basic Knowledge',
        dailyItems: 'Daily Items',
        dangerItems: 'Dangerous Goods',
        testTip: 'Test tips',
        startTest: 'Start test',
        quitTest: 'Quit test',
        submitTest: 'Submit test',
        tipDoNotClose: 'Tips: Please do not close the paper during the test.',
        tipOneChance: 'You have one chance only, please take it seriously.',
        forReference: 'Note: This test result is for reference only.',
        tipProgress: 'Complete all tests to see the final assessment.',
        cheerUp: 'Keep going!',
        viewReport: 'View assessment report',
        reportTitle: 'Assessment report',
        rating: 'Assessment Level',
        weakness: 'Weak knowledge point',
        accuracy: 'Correct rate',
        assessTitle: 'We have analyzed the following results based on your evaluation data',
        assessPerfect: 'You are perfect at {0}',
        assessGood: 'You have a basic grasp of {0}',
        assessBad: 'You are not good at {0},need to make efforts',
        assessCheerUp: 'You will be a good security inspector. Good luck!',
        notDone: 'Pre-job evaluation has not been completed'
    },
    http: {
        error: 'Server connection failed',
        forbidden: "You don't have permission",
        serverError: 'Server error',
        timeout: 'Request timed out'
    },
    app: {
        login: 'Login',
        portal: 'Portal Site',
        mobileSite: 'Mobile Site',
        switchTheme: 'Switch theme',
        signOut: 'Sign out',
        changePwd: 'Change the password',
        oldPwd: 'Old password',
        newPwd: 'New password',
        confirmPwd: 'Confirm the password',
        errorPwd: 'The passwords input are inconsistent!',
        bindMobile: 'Bind with mobile number',
        mobile: 'Mobile number',
        code: 'Code',
        getCode: 'Verification code',
        getCodeAgain: 'Re-obtain',
        waitCode: 'Re-obtain after {0}s ',
        bound: 'You have bound with mobile number',
        unbound: 'The phone number has not bound to a user',
        untie: 'Unbind',
        errorMobile: 'Please enter the correct mobile number',
        bindSuccess: 'Successfully bound!',
        untieSuccess: 'Successfully unbound!',
        account: 'Account number or mobile number',
        jobNo: 'Please enter the employee ID',
        enterpriseCode: 'Please enter the company number',
        roleType: 'Please select the identity type',
        admin: 'Administrator',
        trainer: 'Trainer',
        student: 'Student',
        pwd: 'Your password',
        logining: 'Logging in',
        loginNow: 'Login',
        forgetPwd: 'Forget password?',
        retrievePwd: 'Retrieve password',
        pwdLogin: 'Password Login',
        scanLogin: 'Scan Login',
        smsLogin: 'SMS login',
        jobNoLogin: 'Employee ID',
        faceLogin: 'Face recognition',
        faceLoginClick: 'Click to login by face recognition',
        confirmEdit: 'Confirm the modification',
        resetSuccess: 'Your password has been reset and the system will automatically redirect to the login page in {0}s.',
        scanSuccess: 'Login success!',
        qrInvalid: 'QR code has expired',
        freshQR: 'Refresh QR code',
        scanLoginTip: 'Scan QR code to login',
        appName: 'Nuctech',
        dashboard: 'Home',
        track: {
            trackTip: 'Please do not refresh or close the page during the detection process. It is recommended to keep the facial features clear.',
            envMonitoring: 'Monitoring the environment...',
            faceMonitoring: 'Please look at the camera during face recognition.',
            liveMonitoring: 'Successfully captured the face. Implementing liveness detection...',
            camera: 'The platform will take a picture in {0}s. Please keep looking at the camera.',
            checking: 'Verifying...',
            loginSuccess: 'Login successful！'
        },
        copyright: '©2019, NUCTECH COMPANY LIMITED. All Rights Reserved',
    },
    live:{
        myLive: 'My live studio',
        deleteLive: 'Delete live studio',
        roomName: 'Studio Name',
        roomNotice: 'Studio Notice',
        inputName: 'Please input studio name',
        inputNotice: 'Please input studio notice',
        isPassword: 'Need password?',
        password: 'Password',
        getAddress: 'Get live streaming address',
        liveInfo: 'Live Information',
        rtmp: 'Rtmp Address',
        liveCode: 'Live Code',
        tip: 'Note',
        tip1: 'Each time you click to get the streaming code, the live code will be regenerated, and the validity of each live code is 5 minutes.',
        tip2: 'Only switching the push line will cause the RTMP address to change',
        startEndTime: 'Please select start time and end time',
        copy: 'Copy',
        copyFail: 'Copy Failed！',
        creator: 'Anchor',
        onlineNum: 'Online number',
        notStart: "The anchor hasn't started yet",
        left: 'The anchor has left',
        refresh: 'Refresh live status',
        notice: 'Notice',
        noNotice: 'No notice',
        chat: 'Chat',
        audience: 'Audience',
        someFlowers: 'How many flowers can you get on this live broadcast?',
        send: 'Send',
        internetError: 'Network error, please check the network, switch lines or clarity',
        living: 'Live broadcast',
        noLive: 'No live broadcast',
        inputRoomPwd: 'Please input studio password',
        mainLine: 'Main Line',
        overseasLine: 'Overseas Line',
        foldComments: 'Fold comments',
        unfoldComments: 'Unfold comments',
        reload: 'Reload',
    }
}
